function IconButton({
  children,
  type,
  name,
  id,
  className,
  onClick,
  size = "sm",
  appearance = "primary",
  disabled,
}) {
  const appearanceClass = {
    primary:
      "text-indigo-600 bg-indigo-100 hover:bg-indigo-200 focus-visible:outline-indigo-600",
  };
  const sizeClass = {
    xs: "p-1 text-xs",
    sm: "p-2 text-sm",
    md: "p-2.5 text-sm",
    lg: "p-3 text-sm",
    xl: "p-3.5 text-sm",
  };
  return (
    <button
      disabled={disabled}
      name={name}
      id={id}
      onClick={(e) => {
        onClick && onClick(e);
      }}
      type={type || "button"}
      class={`
        ${appearanceClass[appearance]}
        ${className || ""}  
        disabled:text-gray-400 disabled:hover:bg-indigo-50 rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 
        ${sizeClass[size || "md"]}
        `}
    >
      {children}
    </button>
  );
}

export default IconButton;
